import React from 'react';
import { ContactUsBanner } from './modules/ContactUsBanner';
import DropDown from './modules/DropDown';
import DropDownCallMe from './modules/DropDownCallMe'
import ModalDialog from './modules/Popup';
import PopupCallMe from './modules/PopupCallMeOneApp'
import {Title} from '@vds/typography';
import {Input} from '@vds/inputs';
import {RadioButtonGroup} from '@vds/radio-buttons'
import {Line} from '@vds/lines';
import styled from 'styled-components';
import {DropdownSelect} from '@vds/selects';
import {Button} from '@vds/buttons';
import NBA from './modules/NBA';
import { MS_LOCATION, CONTACT_US_PAGE_CATEGORY, CONTACT_US_PAGE_SUBCATEGORY } from '../constants/constants';
import '../assets/css/CallMeOneApp.css';
import '../assets/css/banner.css';
import { RTCICall, MetricRTCICall } from "./modules/RTCICall";
import { getOS, isNullOrUndefined, updateUserID, RemoveHeaderHiddenClass } from "./modules/CommonFunctions";
import ErrorBoundary from './modules/ErrorHandler';
import { SiteCatalyst } from '../components/modules/SiteCatalyst';
import { Chat } from "./modules/IncludeChat";
import CovidAlert from './modules/CovidAlert';
import { Header } from './modules/HeaderContent';
import { Footer } from './modules/FooterContent';
import {setNativeTitleWithNavigation,nativeHideTopBar,nativeUpdateFab, nativeSmartLinkToExternalBrowser} from "../actions/native";
import reactDom from 'react-dom';
import PropTypes from 'prop-types';
//oneapp call me page 
const StyledLineNext = styled.div `height:3px`

class ContactUsCallMePageOneApp extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            scheduleCall: false,
            isOpenPopup :false,
            telNumValue :'',
            istelNumOpt :true,
            AltWarningMessage :'',
            btnConfirmed :true,
            chktelNum :true,
           // errCodeStatus: false,

        }
        
        this.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;
        this.dialogStyle = (this.isMobile) ? { "top": "50%", "position": "fixed", "transform": "translate(-40%, -45%)" } : { "top": "50%", "position": "fixed", "transform": "translate(20%, -45%)" }
        this.errorElement = "";
        this.autoCompleteRef = React.createRef();
        this.inputRef = React.createRef();
        this.dialogRef = React.createRef();
        this.conformJSON = {};
        this.phoneNumbers = [];
        this.dialogContent = "We cannot process your request at this time.</span><p>For additional assistance, call 1-800-VERIZON (1-800-837-4966)";
        this.PopupWarningMessage = "We cannot process your request at this time.For additional assistance, call 1-800-VERIZON (1-800-837-4966).";
        this.conformData = "";
        this.scheduledTime = "";
        this.successHeader = "Thank you";
        this.failureHeader = "We're sorry";
        this.meridian = "";
        this.pasteActionHandler = this.onPasteValue.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.scheduleCall = this.scheduleCall.bind(this);
        this.handleConfirmCall = this.handleConfirmCall.bind(this);
        this.enableConfirmButton = this.enableConfirmButton.bind(this);
        this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
        this.isValidUser = false;       
        if(window.userinfo !== null && window.userinfo !== undefined) {this.isValidUser = true;}
        this.pegaID = (this.isValidUser && !isNullOrUndefined(window.contactUsDynamicData.Attribute) && !isNullOrUndefined(window.contactUsDynamicData.Attribute.content)) ? window.contactUsDynamicData.Attribute.content : "";
        this.topicValue = "";
        this.subTopicValue = "";
        this.timeValue = "";
        this.isLoadWarningPopup = false;
        this.metricsArgs = {
            os: getOS(),
            category: CONTACT_US_PAGE_CATEGORY,
            subCategory: CONTACT_US_PAGE_SUBCATEGORY,
            pegaSessionID: this.pegaID,
            userid: (this.isValidUser) ? window.userinfo.userId : "",
            visionID: (this.isValidUser) ? window.userinfo.visionId : "",
            accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
        } 
        this.BTN = "";
        this.getECRMData();
        this.IsOneApp = false;
        if(window.oneAppFlag == true && window.oneAppFlag != null){
            this.IsOneApp = "";
             this.IsOneApp = true;            
        }
        localStorage.removeItem("IsSelectedCallPlan");
        localStorage.setItem('IsSelectedCallPlan',"");
    }

    componentDidMount() {
       // this.setState(this.isOpenPopup , 'false');
       this.setState({AltWarningMessage: this.PopupWarningMessage});
        updateUserID();
        //   window.constructScData('urlPageLoad','');
		//page title for oneapp
        if(window.oneAppFlag == true && window.oneAppFlag != null){
          nativeHideTopBar(true);
        }
        let operatingSystem = getOS();
        let intent = "";
        let nbaCount = 0;
        if (window.contactUsDynamicData != null && window.contactUsDynamicData.resourcesummary != null) {
            for (let i = 0; i < window.contactUsDynamicData.resourcesummary.length; i++) {
                intent = window.contactUsDynamicData.resourcesummary[i].resourceid;
                let appChannelValue = "";
                let intentlowercase = "";
                intentlowercase = intent.toLowerCase();
                var intentArray = ["ppsh_generic_biml_lowermybill", "ppsh_generic_piml_manageautopay", "ppsh_generic_biml_pmt_arrng",
                                    "ppsh_generic_autopay_cnf","ppsh_generic_outage_ipr"];
                if(intentArray.indexOf(intentlowercase)!== -1)  {
                    //value exists
                    appChannelValue = "ESUPPORT";
                }  
                else{
                    appChannelValue = "NBA-ESUPPORT";
                }               
                // if(intent == "PPSH_Generic_BIML_Lowermybill" || intent == "PPSH_Generic_PIML_Manageautopay" || 
                //     intent == "PPSH_Generic_Biml_PMT_Arrng" || intent == "PPSH_Generic_Autopay_CNF" ||
                //     intent == "PPSH_GENERIC_OUTAGE_IPR"){
                //     appChannelValue = "ESUPPORT";
                // }
                // else{
                //     appChannelValue = "NBA-ESUPPORT";
                // }
                if (intent != null && !isNullOrUndefined(window.contactUsDynamicData.resourcesummary[i].insights.verbiage) && window.contactUsDynamicData.resourcesummary[i].insights.verbiage !== "") {
                    nbaCount = nbaCount + 1;
                    let args = {
                        intentCategory: "NBA_DISPLAY",
                        activityCategory: "NBA_DISPLAY",
                        intent: intent,
                        app_n_channel: "NBA-ESUPPORT",
                        os: operatingSystem,
                        pegaSessionID: (!isNullOrUndefined(window.contactUsDynamicData.Attribute) && !isNullOrUndefined(window.contactUsDynamicData.Attribute.content)) ? window.contactUsDynamicData.Attribute.content : "",
                        userid: (this.isValidUser) ? window.userinfo.userId : "",
                        visionID: (this.isValidUser) ? window.userinfo.visionId : "",
                        accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
                    };
                      RTCICall(args);
                    if (nbaCount === 2) { break; } // NBA RTCI call will send for two items only in page load
                }
            }
        }
        // Chat();
        // if (this.inputRef.current !== null && this.inputRef.current !== undefined) {
        //     let localInstance = this;
        //     this.inputRef.current.addEventListener("paste", this.pasteActionHandler, true);
        // }
        // let imgBannerLink = document.querySelector('.w_right-section-banner li a');
        // let localInstance = this;
        // imgBannerLink.addEventListener('click', ()=> {
        //     MetricRTCICall(localInstance.metricsArgs);
        //     //makeCall('NewContactUs','ContactOptions','wireless');
        //    // saveMetrics('nc_wireless');
        //     // window.scLinkTrackID('go to wireless');
        // })
        RemoveHeaderHiddenClass();

        if(this.phoneNumbers.length){
            document.querySelector('.phoneNumeberRow').classList.add('hidetxnNumdiv');
        }

    }

    navigateBack() {
        window.location.href = window.location.href.substring(0, window.location.href.indexOf('callme') - 1)
    }

    updateDialogContent(content, header) {
       
       localStorage.removeItem("IsSelectedCallPlan");
        localStorage.setItem('IsSelectedCallPlan',"");
         if (document.querySelector('.show_spinner') !== null) {
                 document.querySelector('.show_spinner').classList.remove('show_spinner');
             }
       let warningmessage = content;
       let activeblnn = true;
       this.setState({AltWarningMessage: content});   
        this.setState({isOpenPopup : activeblnn});
    }

    updateData(topic, supTopic, time, GID, meridian, priority) {
        this.scheduledTime = time;
        this.meridian = meridian;
        this.topicValue = topic;
        this.subTopicValue = supTopic;
        this.timeValue = time;
        this.conformJSON = {
            "VZCBRequest": {
                "Header": {
                    "ClientName": "MYFIOS",
                    "ClientIP": "68.134.166.232",
                    "TransactionID": -549845223,
                    "RequestName": "RegisterCallback"
                },
                "Body": {
                    "RegisterCallbackRequest": {
                        "GlobalSessionID": GID,
                        "Topic": topic,
                        "SubTopic": supTopic,
                        "CBType": priority,
                        "CBR": this.BTN.replace(/[^0-9]/g, ''),
                        "QueueName": "NewCustSales_Online",
                        "SelectedSlot": time,
                        "CustomerID": window.userinfo.details.vcustid,
                        "Authenticated": 1,
                        "ACCOUNT_ID": window.userinfo.visionId + window.userinfo.visionAcctId,
                        "ACCOUNT_TYPE": "VISION",
                        "BTN": {}
                    }
                }
            }
        }
    }

    toggleCheckBox(e) {
        
        
        if (e && e.target !== undefined) {
            if (!e.target.classList.contains('checked')) {
                let id = e.target.getAttribute('for');
                e.target.parentElement.querySelector("#" + id).checked = true;
                let prevItem = document.querySelector('.checked').getAttribute('for');
                document.querySelector('#' + prevItem).checked = false;
                document.querySelector('.checked').classList.remove('checked');
                e.target.classList.add('checked');
                this.BTN = !isNullOrUndefined(e.target.innerText) ? e.target.innerText : "";
                //this.inputRef.current.value = '';
                if(this.phoneNumbers.length){
                    document.querySelector('.phoneNumeberRow').classList.add('hidetxnNumdiv');
                }
            }
            if (document.querySelector('.custom_checkbox').checked) {
                if(this.phoneNumbers.length){
                    document.querySelector('.phoneNumeberRow').classList.remove('hidetxnNumdiv');
                }
                this.BTN = this.state.telNumValue;
            }
            
        } else {
            this.BTN = this.state.telNumValue;
        }
    }



    closeDialog(e) {
        if (!isNullOrUndefined(e.keyCode) && (e.keyCode !== 13 && e.keyCode !== 27)) {
            return;
        }
        this.dialogRef.current.classList.add('hide_dialog');
        document.getElementsByClassName('page-overlay')[0].classList.add('hide_dialog');
        document.getElementsByClassName('page-overlay')[0].classList.remove('active');
        this.dialogRef.current.classList.remove('active');
        document.querySelector('.hide_spinner').classList.add('show_spinner');
      
        const IsFiosFlag = localStorage.getItem('IsFiosOnlyFlag');//CXTDT-250100
        if(IsFiosFlag == 'true'){           
            window.location.href = window.location.href.substring(0, window.location.href.indexOf('callme') - 1) +"/contactuslanding.htm?src=FiosOnly";           
        }else{           
          window.location.href = window.location.href.substring(0, window.location.href.indexOf('callme') - 1)
        }
    }

    openDialogPopup(){
        //this.updateDialogContent("Success testing","Welocme content");
      
        let activeblnn = true;
                this.setState({isOpenPopup: activeblnn})
    }

    LoadCallMe(){
        //this.setState({errCodeStatus: false})
        window.history.back();
    }
    handleConfirmCall(e) {
        if (e.keyCode === 13) {
            this.scheduleCall();
        }
    }

    setPhoneNumber(evt){
        let value = evt.target.value;
        setTimeout(() => {
        this.setState({telNumValue: value})
        this.BTN = this.state.telNumValue;  
        }, 100)
    }

    handleChange = e => {
        const { name, value } = e.target;
        const isChecked = e.target.checked;
    
        this.setState({
          [name]: value,
          istelNumOpt :isChecked
        });
      };
    
    
    
      validateCheckBox(input) {
        let tnvalcheck = this.state.telNumValue;
        this.updateErrorElement();
        if (input == "" ) {
            this.errorElement.classList.add('validated');
          this.errorElement.innerText = "Please enter a valid 10 digit phone number";

        }         
        else {
            if (tnvalcheck.length < 10) {
                this.errorElement.classList.add('validated');
                this.errorElement.innerText = "Please enter a valid 10 digit phone number";
            }
            else{
            this.errorElement.classList.remove('validated');
            }
        }
        if (tnvalcheck.length === 10) {
            const checkSameVal = input.value.split('').every(function (value) {
                return value === input.value[0];
            })
            if (checkSameVal) {
                this.errorElement.innerText = "All digits are same, Please check."
                this.errorElement.classList.add('validated');
            }
        }
        
    }

    validatePhoneNumber() {
        this.validateCheckBox(this.state.telNumValue);
        this.BTN = this.state.telNumValue;
    }
    updateErrorElement() {
        this.errorElement = document.querySelector('.error');
    }

    scheduleCall() {
        let selectedCallPlanVal = localStorage.getItem("IsSelectedCallPlan");
        let rdtelnumopt = this.state.istelNumOpt;
        this.isLoadWarningPopup = true;
      //  let Urls ="https://wwwawssit.ebiz.verizon.com/support";//test code
        if (this.BTN === "") {
            if (!document.querySelector('.custom_checkbox').checked) {
                this.BTN = this.phoneNumbers[0] ? this.phoneNumbers[0] : this.validatePhoneNumber();
            } else {
                this.validatePhoneNumber();
                return;
            }
        }
        let tnval = this.state.telNumValue;
        if(tnval.length < 10 && document.querySelector('.custom_checkbox').checked){
            this.validatePhoneNumber();
            return;
        }
        document.querySelector('.hide_spinner').classList.add('show_spinner');
        let localInstance = this;
        if (this.timeValue !== "" && !isNullOrUndefined(this.timeValue)) {
            //  window.scLinkTrackID("confirm- " + this.timeValue + " " + this.topicValue + ": " + this.subTopicValue);
        } else {
            //  window.scLinkTrackID("confirm- " + this.topicValue + ": " + this.subTopicValue);
        }
        fetch(MS_LOCATION+ "/callme/register", {
            method: "POST",
            headers: new Headers({
                'content-type': 'application/json'
            }),
            body: JSON.stringify(localInstance.conformJSON)
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
            if (document.querySelector('.show_spinner') !== null) {
                document.querySelector('.show_spinner').classList.remove('show_spinner');
            }
            if (json.VZCBResponse !== undefined && json.VZCBResponse !== null && json.VZCBResponse.Body.RegisterCallbackResponse.StatusCode === 0) {
                if (selectedCallPlanVal !== undefined) {
                    let selectedDate =selectedCallPlanVal;
                    selectedDate = (selectedDate.indexOf('today') > -1) ? "Today, " + localInstance.scheduledTime + " " + localInstance.meridian : (selectedDate.indexOf('Tomorrow') > -1) ? "Tomorrow, " + localInstance.scheduledTime + " " + localInstance.meridian : "as soon as an agent is available";
                    let dialogContent = "Your call is scheduled for. " + selectedDate;
                   // localInstance.updateDialogContent(dialogContent, localInstance.successHeader);
                   localInstance.updateDialogContent(dialogContent, localInstance.failureHeader);
                } else {
                    let dialogContent = "Your call is scheduled for. Today, as soon as an agent is available";
                   // localInstance.updateDialogContent(dialogContent, localInstance.successHeader);
                   localInstance.updateDialogContent(dialogContent, localInstance.failureHeader);
                }
                //let dialogContent = "Today, as soon as an agent is available Please remember times are approximate and may vary according to agent availability.";
                //localInstance.updateDialogContent(localInstance.dialogContent, "Success");

            } 
            else if ( json.VZCBResponse.Body.RegisterCallbackResponse.StatusCode === -1) {

           // this.setState({errCodeStatus: true})

            let dialogContent = "We cannot process your request at this time. \nFor additional assistance, call 1-800-VERIZON (1-800-837-4966).";
            localInstance.updateDialogContent(dialogContent, localInstance.failureHeader);
            }
            else {
                let dialogContent = "Today, as soon as an agent is available.";
                localInstance.updateDialogContent(dialogContent, "Success");
            }
        }).catch(function (e) {
           
          //  let getopenstate = this.state.isOpenPopup;    
          //let strCallplan = this.state.selectCallPlan;       
            localInstance.updateDialogContent("Register has been failed ", "Failure");
        })

    }

    
    enableConfirmButton(e) {
        let strvalue = false;
        this.setState({ btnConfirmed:false });
    }

    onPasteValue(e) {
        e.preventDefault();
        var newValue = this.inputRef.current.value + e.clipboardData.getData("Text");
        if (newValue.length > 10) {
            this.inputRef.current.value = newValue.substring(0, 10);
        }
    }

    getECRMData() {
        this.phoneNumbers = [];
        if (this.props.ECRMData === null || this.props.ECRMData === undefined) { this.phoneNumbers = []; return }
        if (Object.keys(this.props.ECRMData).length === 0 || (Object.keys(this.props.ECRMData).length > 0 && this.props.ECRMData.ecrmStatus !== "success")) {
            this.phoneNumbers = [];
            //this.phoneNumbers.push(this.changeNUmberIntoMaskFormat("9884335613"));
            //this.phoneNumbers.push(this.changeNUmberIntoMaskFormat("9884335614"));
           // this.phoneNumbers.push(this.changeNUmberIntoMaskFormat("9884335617"));          
             return
        }
        if (this.props.ECRMData !== null && this.props.ECRMData !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData !== undefined) {
            if (!isNullOrUndefined(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.LookupStatus) && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.LookupStatus.toLowerCase() === "failed") {
                this.phoneNumbers = [];
                return;
            }
            if (this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN !== "") {
               this.phoneNumbers.push(this.changeNUmberIntoMaskFormat(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN.toString()));
               
            }
            if (this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.AlternateTN !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.AlternateTN !== undefined) {
                this.phoneNumbers.push(this.changeNUmberIntoMaskFormat(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.AlternateTN.toString()));
              
            }
            if (this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo.MTN !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo.MTN !== undefined) {
                this.phoneNumbers.push(this.changeNUmberIntoMaskFormat(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo.MTN.toString()));
               
            }
            if (this.phoneNumbers.length > 0) {
                this.BTN = this.phoneNumbers[0]
            }
        }
       //// this.phoneNumbers.push(this.changeNUmberIntoMaskFormat("9884335613"));
       // this.phoneNumbers.push(this.changeNUmberIntoMaskFormat("9176254192"));
        // this.phoneNumbers.push({
        //     name: 'group',
        //     label: this.changeNUmberIntoMaskFormat("9884335613"),                                                                       
        //     value: '9884335613',
        //     ariaLabel: 'radio one',
        //     disabled: false
        //     }  )
        // this.phoneNumbers.push({
        //     name: 'group',
        //     label: this.changeNUmberIntoMaskFormat("9176254192"),                                                                       
        //     value: '9176254192',
        //     ariaLabel: 'radio one',
        //     disabled: false
        //     }  )
       
    }

    changeNUmberIntoMaskFormat(phoneNumber) {
        return + phoneNumber.substring(0, 3) + "." + phoneNumber.substring(3, 6) + "." + phoneNumber.substring(6);
    }

    render() {    
            
        if (this.isValidUser && !this.state.isOpenPopup) {
            return (
                <React.Fragment>                   
                    <section className="contactuspages mob-contactusApp" id="cu_main" role="region">
                        <div className="container">
                            
                            <div className="row contactus-page" id="callMeSection">
                                <div className="columns call-schedule medium-7 myfios-first_col">
                                    <div className="w_talk-tile">
                                        <div className="w_tile-top-content" id="">
                                            <div className="mainTitle">
                                                <Title size="large" bold={true}  viewport="mobile">Schedule a callback</Title> 
                                            </div>                                          
                                            <br></br>
                                            <div className="titleDescription">Enter a phone number and choose a reason. </div>
                                            <br></br>
                                            <Line 
                                                type="heavy"
                                                inverted={false}
                                            />
                                        
                                            <div className="w_head-content">
                                                
                                            {
                                            this.phoneNumbers.map((item, index) => {
                                                return <React.Fragment key={item}>
                                                    <div className="buttonRadio">
                                                        <input data-cs-mask type="radio" defaultChecked={(index === 0) ? true : false} className={"m_phone-" + index} id={"radio" + index} tabIndex="0" value={item} />
                                                        <label htmlFor={"radio" + index} role="radio" aria-checked={(index === 0) ? true : false} aria-required={false} className={(index === 0) ? " checked checkbox" : "checkbox"} onClick={this.toggleCheckBox.bind(this)}>
                                                            <span className="vdsCustomRadioButton"></span>
                                                            {item}
                                                        </label>
                                                    </div>
                                                    <Line 
                                                        type="xLight"
                                                        inverted={false}
                                                    />
                                                    <br />
                                                    </React.Fragment>
                                                })
                                            }
                                                                
                                        
                                               <div className="buttonRadio">
                                                    <input data-cs-mask type="radio" defaultChecked={(this.phoneNumbers.length > 0) ? false : true} className={"custom_checkbox m_phone-" + this.phoneNumbers.length} id={"radio" + this.phoneNumbers.length} name="" tabIndex="0" />
                                                        <label htmlFor={"radio" + this.phoneNumbers.length} role="radio" className={(this.phoneNumbers.length > 0 ? "checkbox" : "checked checkbox")} aria-checked={(this.phoneNumbers.length > 0) ? false : true} aria-required={false} onClick={this.toggleCheckBox.bind(this)}>
                                                            <span className="vdsCustomRadioButton"></span>
                                                            New number
                                                        </label>
                                                </div>
                                                <div className="phoneNumeberRow">
                                                    <label> <span className="hUtPeG">Enter phone number</span></label>
                                                    <Input 
                                                        type="tel"  
                                                         id ="telnum"                                                                                                                
                                                         onChange={this.setPhoneNumber.bind(this)}
                                                         value={this.state.telNumValue}
                                                        readOnly={false}
                                                        required={false}
                                                        disabled={false}
                                                    />
                                                </div> 
                                                <span className="error"></span>       
                                            </div>
                                            <Line 
                                                type="xLight"
                                                inverted={false}
                                            />
                                           
                                            <div className="titleHeading">
                                                <Title size="large"  bold viewport="mobile">Reason for call</Title> 
                                            </div>
                                            <div className="selectDropDownRow">
                                                <ErrorBoundary>
                                                    <DropDownCallMe GID={this.props.globalSessionID} DDlData={this.props.ContactData.callMe[0]}  EnableConfirmButton={this.enableConfirmButton} ConformCall={this.updateData.bind(this)} />
                                                </ErrorBoundary>
                                            </div>
                                            <div className="submit_btn">
                                               {/* <a className="submit_button button p-50 " id="callmeButton" tabIndex="0" role="button" onClick={this.scheduleCall.bind(this)} onKeyDown={this.handleConfirmCall.bind(this)} data-track="Confirm">Confirm</a> */}
                                               <Button 
                                                   id="callmeButton"
                                                    size="large"
                                                    inverted={false} 
                                                    disabled={this.state.btnConfirmed} 
                                                    secondary={false}
                                                    onClick={this.scheduleCall.bind(this)}
                                                    onKeyDown={this.handleConfirmCall.bind(this)}
                                                    >
                                                    Confirm
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="spinner" className="hide_spinner">
                                    <div data-page-loader className="text-center page-loader text-white active">
                                        <div className="loader small text-center"></div> </div>
                                    <center><img alt="spinner" src="/content/dam/verizon/support/consumer/supportservices/vcm-react/media/spinner.gif" /></center>
                                </div>
                            </div>
                        </div>                       
                    </section>
                    <ErrorBoundary>
                        <Footer />
                    </ErrorBoundary>
                    <input type="hidden" value="Auth" id="loginType" />
                    <ErrorBoundary>
                        <SiteCatalyst PageDetails={this.props.ContactData.pagedetails} />
                    </ErrorBoundary>
                </React.Fragment>
            )
        } else if(this.state.isOpenPopup){
            return(
                <React.Fragment>
                     <section className="contactuspages" id="cu_main" role="region">
                        <div className="container">
                            <div className="row contactus-page" id="callMeSection">
                                <div className="columns call-schedule medium-7 myfios-first_col">
                                    <div className="thankYouWrapper">
                                        <div className="thankYouInnerRow">
                                            <Title size="large"  bold viewport="mobile">Thank you.</Title>
                                                
                                            <Line 
                                                type="heavy"
                                                inverted={false}
                                            />
                                        
                                        <div className="paraSpace"> Your call is scheduled for: </div>

                                            <Title size="small"  viewport="mobile">{this.state.AltWarningMessage}</Title>

                                        <div className="paraSpace paraDescription" >Please remember times are approximate and may vary according to agent availability.</div>
                                        </div>
                                        <div className="PopupButton">
                                            {/* <a className="submit_button button p-50 " id="callmeButton" tabIndex="0" role="button" onClick={this.scheduleCall.bind(this)} onKeyDown={this.handleConfirmCall.bind(this)} data-track="Confirm">Confirm</a> */}
                                            <Button 
                                                size="large"
                                                inverted={false} 
                                                disabled={this.state.btnConfirmed} 
                                                secondary={false}
                                                onClick={e => this.LoadCallMe()}>
                                                Done
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <div id="spinner" className="hide_spinner">
                                    <div data-page-loader className="text-center page-loader text-white active">
                                        <div className="loader small text-center"></div> </div>
                                    <center><img alt="spinner" src="/content/dam/verizon/support/consumer/supportservices/vcm-react/media/spinner.gif" /></center>
                                </div>
                            </div>
                        </div>
                    </section>
                </React.Fragment>
            )
        }
        else {
            return (
                <React.Fragment>
                    {console.log('Please login to continue')}
                    <ErrorBoundary>
                        <Header />
                    </ErrorBoundary>
                    <div className="continue-login">Please login to continue with this Page</div>
                    <ErrorBoundary>
                        <Footer />
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <SiteCatalyst PageDetails={this.props.ContactData.pagedetails} />
                    </ErrorBoundary>
                </React.Fragment>
            )
        }
    }
}

export default ContactUsCallMePageOneApp


// WEBPACK FOOTER //
// ./src/components/ContactUsCallMePageOneApp.js